import { Card } from '@/components/ui/card';

export const Kpi = ({ icon: Icon, label, value, sub, testId, tone = 'default' }) => (
  <Card className="jw-card p-5 relative overflow-hidden" data-testid={testId}>
    {tone === 'brand' && <div className="absolute -right-8 -top-8 w-32 h-32 rounded-full opacity-20 blur-2xl jw-gradient-bg" />}
    <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--jw-text-muted)' }}><Icon className="w-4 h-4" /> {label}</div>
    <p className="font-display text-3xl font-bold mt-2">{value}</p>
    {sub && <p className="text-xs mt-1" style={{ color: 'var(--jw-text-subtle)' }}>{sub}</p>}
  </Card>
);
